<button color="accent" mat-raised-button (click)="viewCustomerHistory()">View Customer History</button>
